module.exports = __webpack_public_path__ + "static/media/mechanic.c1a610fb.jpg";